export default "__VITE_ASSET__9b65735c__"